"use client";

import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormikContext } from "formik";

import kebabToCamelCase from "@shared/functions/kebabToCamelCase";

import {
  type CommonTileProps,
  createTileClassNames,
} from "./common-tile-resources";

interface TileProps extends CommonTileProps {
  description?: string;
  iconLeft?: React.ReactNode;
  iconRight?: React.ReactNode;
}

export function Tile({
  className,
  color,
  description,
  iconLeft,
  iconRight,
  componentStyle,
  value,
  label,
  ...rest
}: TileProps) {
  const classNames = createTileClassNames(
    { className, color, componentStyle },
    "default",
  );

  const formikContext = useFormikContext<any>();

  const fieldName = formikContext
    ? kebabToCamelCase(formikContext?.values.stepName)
    : "";

  let loading = false;

  const defaultIconRight = <FontAwesomeIcon icon={faChevronRight} />;

  // special behavior for benefits survey
  const benefitsSurveyQuestionValuesObject = formikContext?.values[fieldName];

  let benefitsSurveyValue;

  if (benefitsSurveyQuestionValuesObject) {
    benefitsSurveyValue = benefitsSurveyQuestionValuesObject.answer
      ? "yes"
      : "no";
  }

  if (
    (formikContext?.isSubmitting &&
      formikContext?.values[fieldName] == value) ||
    (formikContext?.isSubmitting && benefitsSurveyValue == value)
  ) {
    loading = true;
  }
  //

  if (loading) {
    iconRight = <FontAwesomeIcon icon={faSpinner} spin />;
  }

  return (
    <button
      disabled={loading}
      type="submit"
      className={classNames}
      value={value}
      {...rest}
    >
      {iconLeft && <span className="tile__icon">{iconLeft}</span>}
      {description ? (
        <>
          <span className="tile__text">
            <span
              className="tile__label"
              dangerouslySetInnerHTML={{ __html: label || "" }}
            />
            <span className="tile__description">{description}</span>
          </span>
        </>
      ) : (
        <span
          className="tile__label"
          dangerouslySetInnerHTML={{ __html: label || "" }}
        />
      )}
      <span className="tile__icon">{iconRight || defaultIconRight}</span>
    </button>
  );
}
